import { FormRenderProps } from "./form-t";

function getError(
  formProps: FormRenderProps,
  key: string,
  checkTouch: boolean = true,
) {
  const {
    errors: { [key]: error },
    touched: { [key]: touched },
    submitCount,
  } = formProps;

  if (checkTouch && !touched && submitCount === 0) {
    return null;
  }

  return error || null;
}

export default getError;
